import { render } from "./Engenheiro.vue?vue&type=template&id=4253d694"
import script from "./Engenheiro.vue?vue&type=script&lang=ts"
export * from "./Engenheiro.vue?vue&type=script&lang=ts"
script.render = render

export default script